import { render, staticRenderFns } from "./HandleResetPassword.vue?vue&type=template&id=74f77d0e&scoped=true&"
import script from "./HandleResetPassword.vue?vue&type=script&lang=js&"
export * from "./HandleResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f77d0e",
  null
  
)

export default component.exports